// src/data/articlesData.js

export const articles = [
  {
    id: 1,
    slug: "all-about-breast-cancer",
    title: "All About Breast Cancer",
    description: "Breast cancer is a condition where the cells in the breast grow out of control. Breast cancer begins in different parts of the breast, which",
    tag: "August 22, 2024",
    readTime: "8 min read",
    image: "/Resources/breastCancer.png",
    content: `
      <p>Breast cancer is a condition where the cells in the breast grow out of control.</p>
      <p>Breast cancer begins in different parts of the breast, which include the lobules, ducts, and connective tissue.</p>
      <ul>
        <li><strong>Lobules</strong> – Glands that produce milk</li>
        <li><strong>Ducts</strong> – Tubes that carry milk to the nipple</li>
        <li><strong>Connective tissue</strong> – Surrounds and holds the breast</li>
        <li><strong>Nipples</strong> – Raised dark region of tissue on the surface of the breast</li>
      </ul>
      <p>There are different breast cancers, most of which begin in the ducts or lobules. Breast cancer can also spread to other parts of the body.</p>
      <h2>Signs and Symptoms of Breast Cancer</h2>
      <p>During the initial stages, the tumor may be too small to be identified. The first sign of breast cancer is usually a lump in the breast, although not all lumps are cancerous.</p>
      <ul>
        <li>Lump or mass in the breast that feels different from the surrounding tissue</li>
        <li>Pain in the breast</li>
        <li>Red or discoloured scarring of breast skin</li>
        <li>Breast swelling (complete or part of the breast)</li>
        <li>Nipple discharge</li>
        <li>Peeling, flaking or scaling of the skin on the nipple or breast</li>
        <li>Sudden or unexplained change in the shape or size of the breast</li>
        <li>Inverted nipple</li>
        <li>Lump or swelling under your arm</li>
      </ul>
      <h2>Causes and Risk Factors</h2>
      <ul>
        <li>Age (55 years or older)</li>
        <li>Sex (more in women than men)</li>
        <li>Family history and genetics</li>
        <li>Smoking</li>
        <li>Drinking alcohol</li>
        <li>Obesity</li>
        <li>Exposure to radiation</li>
        <li>Hormone replacement therapy</li>
        <li>Physical inactivity</li>
      </ul>
      <h2>Early Detection and Diagnosis</h2>
      <p>Early detection is the key — it increases the survival rate by 98%. Tests include breast exam, mammogram, breast ultrasound, biopsy, and breast MRI.</p>
      <h2>Treatment Options</h2>
      <p><strong>Surgery</strong>: Lumpectomy (removal of tumor) or Mastectomy (removal of entire breast).</p>
      <p><strong>Chemotherapy</strong>: Medications to shrink or kill cancer cells.</p>
      <p><strong>Hormonal therapy</strong>: Blocking cancer cells from growing.</p>
      <p><strong>Radiation therapy</strong>: High-energy X-rays to kill cancer cells.</p>
      <h2>How to Prevent Breast Cancer</h2>
      <ul>
        <li>Breastfeed for one year or more if possible</li>
        <li>Limit alcohol and smoking</li>
        <li>Maintain a healthy weight</li>
        <li>Exercise regularly</li>
        <li>Eat healthy food</li>
        <li>Regular breast checkup and mammogram after age 35</li>
      </ul>
    `
  },
  {
    id: 2,
    slug: "the-food-mood-connection-diet-and-pms-2",
    title: "The Food-Mood Connection: Understanding the Link Between Your Diet and PMS",
    description: "Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue.",
    tag: "August 22, 2024",
    readTime: "5 min read",
    image: "/Resources/diet.jpg",
    content: `
      <p>Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue. While lifestyle changes such as exercise and stress management can help, diet plays a crucial role too.</p>
      <h2>How Diet Affects PMS</h2>
      <p>What you eat directly influences hormone levels and neurotransmitter activity, which can worsen or relieve PMS symptoms.</p>
      <h2>Foods to Eat</h2>
      <ul>
        <li>Complex carbohydrates (oats, whole grains) to stabilize blood sugar</li>
        <li>Calcium-rich foods (dairy, leafy greens) to reduce cramps</li>
        <li>Magnesium-rich foods (nuts, seeds, dark chocolate) to ease mood swings</li>
        <li>Vitamin B6 foods (bananas, chickpeas) for serotonin production</li>
        <li>Omega-3 fatty acids (salmon, flaxseeds) to reduce inflammation</li>
      </ul>
      <h2>Foods to Avoid</h2>
      <ul>
        <li>Salt — worsens bloating and water retention</li>
        <li>Caffeine — can increase anxiety and breast tenderness</li>
        <li>Alcohol — disrupts hormone balance</li>
        <li>Sugar — causes energy crashes and mood swings</li>
        <li>Processed foods — high in salt, fat, and additives</li>
      </ul>
      <h2>Conclusion</h2>
      <p>Making mindful dietary changes in the weeks before your period can significantly reduce the severity of PMS symptoms. Consult your gynecologist if symptoms persist.</p>
    `
  },
  {
    id: 3,
    slug: "everything-you-need-to-know-about-pms-faqs",
    title: "Everything You Need to Know About Premenstrual Syndrome (PMS)",
    description: "Premenstrual Syndrome (PMS) is a common condition that affects women of reproductive age. It is characterized by various physical and emotional symptoms.",
    tag: "June 26, 2024",
    readTime: "10 min read",
    image: "/Resources/pms.jpg",
    content: `
      <p>Premenstrual Syndrome (PMS) is a common condition affecting women of reproductive age, characterized by physical and emotional symptoms occurring in the days before menstruation.</p>
      <h2>What Is PMS?</h2>
      <p>PMS refers to a wide range of symptoms that start after ovulation and end when your period begins. The exact cause isn't fully known, but hormonal changes play a major role.</p>
      <h2>Common PMS Symptoms</h2>
      <ul>
        <li>Mood swings, irritability, anxiety, or depression</li>
        <li>Bloating, breast tenderness, headaches</li>
        <li>Fatigue and sleep problems</li>
        <li>Food cravings or appetite changes</li>
        <li>Difficulty concentrating</li>
      </ul>
      <h2>When to See a Doctor</h2>
      <p>If symptoms are severe enough to interfere with daily life, you may have Premenstrual Dysphoric Disorder (PMDD). Consult your gynecologist for proper diagnosis and treatment.</p>
      <h2>Management Strategies</h2>
      <ul>
        <li>Regular aerobic exercise</li>
        <li>Balanced diet with reduced salt, caffeine, and alcohol</li>
        <li>Adequate sleep (7–9 hours)</li>
        <li>Stress-reduction techniques like yoga and meditation</li>
        <li>Calcium and vitamin B6 supplements (consult doctor first)</li>
      </ul>
    `
  },
  {
    id: 4,
    slug: "things-to-know-about-premenstrual-syndrome-pms",
    title: "Things to Know About Premenstrual Syndrome (PMS)",
    description: "The Invisible Struggle: All About Premenstrual Syndrome — a group of mental, emotional, physical, and behavioural disturbances experienced by a woman before her period.",
    tag: "June 26, 2024",
    readTime: "6 min read",
    image: "/Resources/pms2.jpg",
    content: `
      <p>Premenstrual syndrome (PMS) is a group of mental, emotional, physical, and behavioural disturbances experienced by a woman before her monthly menstrual cycle.</p>
      <h2>How Common Is PMS?</h2>
      <p>PMS affects up to 75% of women during their childbearing years. Symptoms typically appear 1–2 weeks before menstruation and resolve within a few days after it begins.</p>
      <h2>Physical Symptoms</h2>
      <ul>
        <li>Bloating and weight gain</li>
        <li>Breast tenderness</li>
        <li>Acne flare-ups</li>
        <li>Headaches and backaches</li>
        <li>Cramping</li>
      </ul>
      <h2>Emotional and Behavioural Symptoms</h2>
      <ul>
        <li>Irritability, anger, or mood swings</li>
        <li>Anxiety or tension</li>
        <li>Crying spells</li>
        <li>Depressed mood</li>
        <li>Social withdrawal</li>
      </ul>
      <h2>Treatment</h2>
      <p>Treatment includes lifestyle changes, dietary adjustments, and in some cases, medication such as antidepressants or hormonal contraceptives prescribed by a doctor.</p>
    `
  },
  {
    id: 5,
    slug: "the-food-mood-connection-diet-and-pms",
    title: "The Food-Mood Connection: Understanding the Link Between Your Diet and PMS",
    description: "Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue.",
    tag: "June 26, 2024",
    readTime: "6 min read",
    image: "/Resources/pms3.jpg",
    content: `
      <p>Nutrition plays a powerful role in how you feel throughout your menstrual cycle. Small dietary shifts can make a significant difference in PMS severity.</p>
      <h2>The Hormonal-Diet Link</h2>
      <p>Estrogen and progesterone fluctuations affect serotonin levels, which control mood. Eating the right foods supports your body's hormonal balance.</p>
      <h2>Key Nutrients That Help</h2>
      <ul>
        <li><strong>Calcium:</strong> Found in dairy, almonds, and broccoli — reduces PMS symptoms by up to 48%</li>
        <li><strong>Magnesium:</strong> In dark chocolate, spinach — alleviates bloating and mood issues</li>
        <li><strong>Vitamin D:</strong> Sunlight and fortified foods — supports calcium absorption</li>
        <li><strong>Iron:</strong> Lean meats, legumes — combats fatigue</li>
      </ul>
      <h2>Practical Tips</h2>
      <ul>
        <li>Eat small, frequent meals to stabilize blood sugar</li>
        <li>Stay well hydrated</li>
        <li>Reduce processed food intake in the 2 weeks before your period</li>
        <li>Track your diet and symptoms to identify personal triggers</li>
      </ul>
    `
  },
  {
    id: 6,
    slug: "the-menopause-transition-what-to-expect-and-how-to-cope",
    title: "The Menopause Transition: What to Expect and How to Cope",
    description: "Menopause is a natural biological process that marks the end of a woman's reproductive years. It usually occurs between the ages of 45 and 55.",
    tag: "March 29, 2024",
    readTime: "6 min read",
    image: "/Resources/menopause.jpg",
    content: `
      <p>Menopause is a natural biological process that marks the end of a woman's menstrual cycles. It is diagnosed after 12 months without a menstrual period, typically occurring in the late 40s or early 50s.</p>
      <h2>Stages of Menopause</h2>
      <ul>
        <li><strong>Perimenopause:</strong> The transition phase, lasting several years before menopause</li>
        <li><strong>Menopause:</strong> When periods have stopped for 12 consecutive months</li>
        <li><strong>Postmenopause:</strong> The years following menopause</li>
      </ul>
      <h2>Common Symptoms</h2>
      <ul>
        <li>Hot flashes and night sweats</li>
        <li>Vaginal dryness and discomfort</li>
        <li>Sleep disturbances</li>
        <li>Mood changes, including anxiety and depression</li>
        <li>Weight gain and slowed metabolism</li>
        <li>Thinning hair and dry skin</li>
      </ul>
      <h2>How to Cope</h2>
      <ul>
        <li>Regular exercise, especially strength training</li>
        <li>Heart-healthy diet rich in calcium and vitamin D</li>
        <li>Hormone Replacement Therapy (HRT) — consult your doctor</li>
        <li>Mindfulness and stress management</li>
        <li>Regular health screenings for bone density and heart health</li>
      </ul>
    `
  },
  {
    id: 7,
    slug: "know-more-about-menopause",
    title: "Know More About Menopause",
    description: "Menopause is the end of a woman's menstrual periods, and she can no longer bear children. It is a natural part of aging.",
    tag: "March 29, 2024",
    readTime: "6 min read",
    image: "/Resources/menopause2.jpg",
    content: `
      <p>Menopause is the end of a woman's menstrual periods. It is a natural part of aging and usually occurs in women in their late 40s to early 50s.</p>
      <h2>What Causes Menopause?</h2>
      <p>Menopause happens because the ovaries stop producing the hormones estrogen and progesterone. This can occur naturally with age, or due to surgery (removal of ovaries), chemotherapy, or radiation.</p>
      <h2>Key Facts</h2>
      <ul>
        <li>Average age of natural menopause is 51</li>
        <li>Premature menopause occurs before age 40</li>
        <li>Symptoms can last 7–14 years</li>
        <li>Estrogen loss increases risk of osteoporosis and heart disease</li>
      </ul>
      <h2>Health Checks After Menopause</h2>
      <ul>
        <li>Bone density scan (DEXA scan)</li>
        <li>Cholesterol and blood pressure monitoring</li>
        <li>Regular pelvic exams and mammograms</li>
        <li>Blood glucose testing</li>
      </ul>
    `
  },
  {
    id: 8,
    slug: "hormonal-imbalances-pcos-relief-2",
    title: "Hormonal Imbalances: Living with PCOS and Finding Relief",
    description: "Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS).",
    tag: "March 29, 2024",
    readTime: "6 min read",
    image: "/Resources/hormonal.jpg",
    content: `
      <p>Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS). PCOS affects up to 10% of women of reproductive age.</p>
      <h2>What Is PCOS?</h2>
      <p>PCOS is a hormonal disorder in which the ovaries produce excess androgens (male hormones). This can lead to irregular periods, cysts on the ovaries, and difficulty conceiving.</p>
      <h2>Symptoms of PCOS</h2>
      <ul>
        <li>Irregular or absent periods</li>
        <li>Excess facial or body hair (hirsutism)</li>
        <li>Acne and oily skin</li>
        <li>Weight gain, especially around the abdomen</li>
        <li>Hair thinning or male-pattern baldness</li>
        <li>Difficulty getting pregnant</li>
      </ul>
      <h2>Management and Treatment</h2>
      <ul>
        <li>Weight loss (even 5–10% can restore hormonal balance)</li>
        <li>Low-glycemic diet and regular exercise</li>
        <li>Medications: birth control pills, metformin, or anti-androgens</li>
        <li>Fertility treatments if pregnancy is desired</li>
      </ul>
    `
  },
  {
    id: 9,
    slug: "high-risk-pregnancy-safe-and-healthy-delivery",
    title: "High-Risk Pregnancy: How to Ensure a Safe and Healthy Delivery",
    description: "Pregnancy is a joyful experience, but it can also be challenging, especially when you have a high-risk pregnancy.",
    tag: "March 29, 2024",
    readTime: "6 min read",
    image: "/Resources/pregRisk.jpg",
    content: `
      <p>A high-risk pregnancy occurs when the mother or baby has conditions that increase the chance of health problems before, during, or after delivery.</p>
      <h2>What Makes a Pregnancy High-Risk?</h2>
      <ul>
        <li>Age under 17 or over 35</li>
        <li>Pre-existing conditions: diabetes, hypertension, heart disease, thyroid disorders</li>
        <li>Pregnancy-induced conditions: gestational diabetes, preeclampsia</li>
        <li>Multiple pregnancies (twins, triplets)</li>
        <li>Previous pregnancy complications</li>
        <li>Obesity (BMI over 30)</li>
      </ul>
      <h2>How to Manage a High-Risk Pregnancy</h2>
      <ul>
        <li>Early and regular prenatal care</li>
        <li>Specialist consultations (maternal-fetal medicine)</li>
        <li>Careful monitoring with additional ultrasounds and tests</li>
        <li>Healthy diet and safe physical activity</li>
        <li>Avoid smoking, alcohol, and unnecessary medications</li>
        <li>Mental health support and stress reduction</li>
      </ul>
      <h2>Warning Signs to Watch For</h2>
      <ul>
        <li>Severe headache or vision changes</li>
        <li>Swelling in hands, feet, or face</li>
        <li>Decreased fetal movement</li>
        <li>Vaginal bleeding or unusual discharge</li>
      </ul>
    `
  },
  {
    id: 10,
    slug: "all-about-high-risk-pregnancy",
    title: "All About High-risk Pregnancy",
    description: "A pregnancy in which the mother or baby is at an increased risk for complications or health problems.",
    tag: "September 19, 2023",
    readTime: "6 min read",
    image: "/Resources/pregRisk2.jpg",
    content: `
      <p>A high-risk pregnancy is one in which the mother or baby is at an increased risk for complications or health problems before, during, or after delivery.</p>
      <h2>Common Causes</h2>
      <ul>
        <li>Maternal age over 35</li>
        <li>Pre-existing health conditions</li>
        <li>Lifestyle factors such as smoking or substance use</li>
        <li>Complications from a previous pregnancy</li>
      </ul>
      <h2>Importance of Specialized Care</h2>
      <p>Women with high-risk pregnancies benefit from care provided by a maternal-fetal medicine (MFM) specialist, also called a perinatologist. They work alongside your OB-GYN to monitor both mother and baby closely.</p>
      <h2>Emotional Support</h2>
      <p>A high-risk diagnosis can be stressful. It is important to lean on your support system and communicate openly with your healthcare team about any concerns.</p>
    `
  },
  {
    id: 11,
    slug: "understanding-pcos-symptoms-causes-treatment",
    title: "Understanding PCOS: Symptoms, Causes, and Treatment Options",
    description: "Polycystic ovary syndrome (PCOS) is a common hormonal disorder affecting women of reproductive age.",
    tag: "September 19, 2023",
    readTime: "6 min read",
    image: "/Resources/pcos-age.jpg",
    content: `
      <p>Polycystic ovary syndrome (PCOS) is a common hormonal disorder affecting women of reproductive age. It is estimated that 1 in 10 women of childbearing age has PCOS.</p>
      <h2>What Causes PCOS?</h2>
      <p>The exact cause is unknown, but factors include excess insulin, low-grade inflammation, heredity, and excess androgen production by the ovaries.</p>
      <h2>Symptoms</h2>
      <ul>
        <li>Irregular periods or no periods</li>
        <li>Polycystic ovaries (enlarged ovaries with follicles)</li>
        <li>Excess androgen — elevated levels of male hormones</li>
        <li>Weight gain and difficulty losing weight</li>
        <li>Acne and skin darkening</li>
      </ul>
      <h2>Complications</h2>
      <ul>
        <li>Infertility</li>
        <li>Type 2 diabetes</li>
        <li>Sleep apnea</li>
        <li>Endometrial cancer</li>
        <li>Depression and anxiety</li>
      </ul>
      <h2>Treatment</h2>
      <p>Treatment focuses on managing individual concerns. Lifestyle changes are first-line treatment, followed by medications such as hormonal birth control, metformin, or fertility drugs.</p>
    `
  },
  {
    id: 12,
    slug: "vaginal-cancer-early-detection-prevention",
    title: "Vaginal Cancer: Early Detection and Prevention Strategies",
    description: "Vaginal cancer is a rare but serious condition that can affect women of all ages.",
    tag: "September 19, 2023",
    readTime: "6 min read",
    image: "/Resources/Vaginal-Cancer-1.jpg",
    content: `
      <p>Vaginal cancer is a rare but serious condition that can affect women of all ages. While the exact causes are unknown, certain risk factors have been identified.</p>
      <h2>Risk Factors</h2>
      <ul>
        <li>Human papillomavirus (HPV) infection</li>
        <li>Age (most common in women over 60)</li>
        <li>History of cervical cancer or precancerous lesions</li>
        <li>Smoking</li>
        <li>Exposure to DES (diethylstilbestrol) before birth</li>
      </ul>
      <h2>Symptoms</h2>
      <ul>
        <li>Vaginal bleeding after intercourse or between periods</li>
        <li>Watery vaginal discharge</li>
        <li>Pelvic pain</li>
        <li>A mass or lump in the vagina</li>
        <li>Pain during urination</li>
      </ul>
      <h2>Early Detection</h2>
      <p>Regular pelvic exams and Pap smears are crucial. The HPV vaccine can significantly reduce the risk. Early-stage vaginal cancer has a much higher survival rate.</p>
      <h2>Treatment Options</h2>
      <ul>
        <li>Surgery to remove the cancer</li>
        <li>Radiation therapy</li>
        <li>Chemotherapy (usually combined with radiation)</li>
      </ul>
    `
  },
  {
    id: 13,
    slug: "everything-you-need-to-know-about-vaginal-cancer",
    title: "Everything You Need to Know About Vaginal Cancer",
    description: "Vaginal cancer is one of the rarest cancers affecting the female reproductive system.",
    tag: "August 14, 2023",
    readTime: "6 min read",
    image: "/Resources/Vaginal-Cancer-1536x1024.jpg",
    content: `
      <p>Vaginal cancer is one of the rarest cancers affecting the female reproductive system. The vagina (birth canal) is the pathway through which menstrual blood exits and through which babies are born.</p>
      <h2>Types of Vaginal Cancer</h2>
      <ul>
        <li><strong>Squamous cell carcinoma:</strong> Most common, begins in the thin, flat cells lining the vagina</li>
        <li><strong>Adenocarcinoma:</strong> Begins in glandular cells</li>
        <li><strong>Melanoma:</strong> Begins in pigment-producing cells</li>
        <li><strong>Sarcoma:</strong> Begins in connective tissue or muscle cells</li>
      </ul>
      <h2>Diagnosis</h2>
      <ul>
        <li>Pelvic exam and Pap test</li>
        <li>Colposcopy</li>
        <li>Biopsy</li>
        <li>Imaging tests (MRI, CT scan, PET scan)</li>
      </ul>
      <h2>Outlook</h2>
      <p>The prognosis depends on the stage at diagnosis. Stage I vaginal cancer has a 5-year survival rate of about 84%. Regular screenings and early detection significantly improve outcomes.</p>
    `
  },
  {
    id: 14,
    slug: "hormonal-imbalances-pcos-relief",
    title: "Hormonal Imbalances: Living with PCOS and Finding Relief",
    description: "Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS).",
    tag: "August 14, 2023",
    readTime: "6 min read",
    image: "/Resources/hormonal.jpg",
    content: `
      <p>Living with PCOS can feel overwhelming, but with the right knowledge and care, many women manage the condition effectively and lead healthy lives.</p>
      <h2>Day-to-Day Management</h2>
      <ul>
        <li>Maintain a consistent sleep schedule</li>
        <li>Incorporate 30 minutes of moderate exercise most days</li>
        <li>Follow an anti-inflammatory diet</li>
        <li>Track your menstrual cycle to monitor changes</li>
        <li>Reduce stress through mindfulness or therapy</li>
      </ul>
      <h2>Finding Community and Support</h2>
      <p>Connecting with other women who have PCOS can be incredibly helpful. Support groups, online communities, and counseling can provide emotional support and practical advice.</p>
      <h2>When to Seek Help</h2>
      <p>Always consult a gynecologist if you notice changes in your cycle, unexplained weight gain, or difficulty conceiving. Early intervention leads to better outcomes.</p>
    `
  },
  {
    id: 15,
    slug: "the-role-of-nutrition-in-female-fertility",
    title: "The Role of Nutrition in Female Fertility",
    description: "When it comes to the journey of starting a family, many factors can influence a woman's fertility.",
    tag: "August 14, 2023",
    readTime: "6 min read",
    image: "/Resources/Female-Fertility-1.jpg",
    content: `
      <p>When it comes to the journey of starting a family, many factors can influence a woman's fertility. While genetics, lifestyle choices, and medical conditions play a role, nutrition is one of the most modifiable factors.</p>
      <h2>Nutrients That Support Fertility</h2>
      <ul>
        <li><strong>Folic acid:</strong> Crucial before and during early pregnancy — found in leafy greens, legumes</li>
        <li><strong>Iron:</strong> Low iron is linked to anovulation — found in red meat, spinach</li>
        <li><strong>Zinc:</strong> Supports ovulation — found in pumpkin seeds, shellfish</li>
        <li><strong>Antioxidants:</strong> Vitamins C and E protect egg quality</li>
        <li><strong>Omega-3 fatty acids:</strong> Reduce inflammation and support hormone production</li>
      </ul>
      <h2>The Fertility Diet</h2>
      <ul>
        <li>Eat more plant-based proteins (beans, lentils, nuts)</li>
        <li>Choose full-fat dairy over low-fat for ovulatory function</li>
        <li>Opt for slow-carb foods with low glycemic index</li>
        <li>Limit trans fats found in fried and processed foods</li>
        <li>Stay well hydrated</li>
      </ul>
      <h2>Supplements to Consider</h2>
      <p>A prenatal vitamin with folic acid, vitamin D, and iron is generally recommended for women trying to conceive. Always consult your doctor before starting supplements.</p>
    `
  },
];